<div class="cpu-indicator" *ngIf="cpuUsage$ | async as cpuUsage">
    <div id="label">CPU</div>
    <div id="percentage">{{ cpuUsage }}%</div>
</div>
